'use client';

import { useNuqsNextAppRouterAdapter } from '../../chunk-ZOGZRKNA.js';
import { createAdapterProvider } from '../../chunk-5WWTJYGR.js';

// src/adapters/next/app.ts
var NuqsAdapter = createAdapterProvider(useNuqsNextAppRouterAdapter);

export { NuqsAdapter };
